export default __webpack_public_path__ + "static/media/clock.88d9c214.svg";